module.exports = __webpack_public_path__ + "static/img/color.2f761107.jpg";